/**
 * Manages Sitewide PopUp
 *
 * @see src/templates/layout/skeleton.twig
 * @see https://alpinejs.dev/component/headless-dialog/docs
 * @see src/templates/_partials/global/sitewidePopUp.twig
 *
 * @property $refs
 */
export default ({
  debug = window?.APP?.CONFIG?.DEBUG || false,
  forceOpen = false,
  key = 'SitewidePopUp',
  updatedAt,
  ...opts
}) => {
  return {
    debug,
    isOpen: false, // used for x-model on the dialog/popover/modal
    forceOpen,
    key,
    now: new Date().getTime() / 1000,
    showItAgainAfter: 60 * 60, // 1 hour in seconds
    ...opts,
    init() {
      if (this.debug) {
        console.log('[SitewidePopUp]', {
          key: this.key,
          userHasNotSeen: this.userHasNotSeen,
          now: this.now,
          showItAgainAfter: this.showItAgainAfter,
          isOpen: this.isOpen,
        })
      }
      this.updatedAt = updatedAt
      this.isOpen = this.userHasNotSeen

      // Do side effects for modal closing
      this.$watch('isOpen', () => {
        if (this.debug) {
          console.log(`[SitewidePopUp] ${this.key} isOpen changed to ${this.isOpen}`)
        }
        if (!this.isOpen) {
          this.handleClose()
        }
      })
    },
    get shownAtStorageKey() {
      return `${this.key}-${this.updatedAt}-shownAt`
    },
    get userHasNotSeen() {
      if (this.forceOpen) {
        return true
      }

      const shownAt = Number(localStorage.getItem(this.shownAtStorageKey))

      if (!shownAt) {
        return true
      }

      return (shownAt + this.showItAgainAfter) < this.now
    },
    handleClose() {
      if (this.forceOpen) {
        return
      }
      if (this.debug) {
        console.log(`[SitewidePopUp] ${this.key} handle close`)
      }

      localStorage.setItem(this.shownAtStorageKey, this.now.toString())
    },
  }
}
